import type { SubscriptionAnnualBillingStatDTO } from '../subscriptionBillingStat.types';
import { CostOptimizationPointModel } from './CostOptimizationPointModel';

export class SubscriptionBillingStatModel {
  private readonly _dto: SubscriptionAnnualBillingStatDTO;
  private readonly _optimizationPoints: CostOptimizationPointModel[];

  constructor(dto: SubscriptionAnnualBillingStatDTO) {
    this._dto = dto;
    this._optimizationPoints = dto.optimizationPoints?.map(dto => new CostOptimizationPointModel(dto)) ?? [];
  }

  get originDTO(): SubscriptionAnnualBillingStatDTO {
    return this._dto;
  }

  get id() {
    return `${this._dto.month}_${this._dto.subscription.id}`;
  }

  get annualPaymentEstimate() {
    return this._dto.annualPaymentEstimate ?? 0;
  }

  get monthlyPaymentEstimate() {
    return Math.floor(this.annualPaymentEstimate / 12);
  }

  // 올해 남은 줄일 수 있는 금액
  get remainingAnnualPaymentReductionEstimate() {
    return this._dto.remainingAnnualPaymentReductionEstimate ?? 0;
  }

  get remainingMonthlyPaymentReductionEstimate() {
    return Math.floor(this.remainingAnnualPaymentReductionEstimate / 12);
  }

  get subscriptionId() {
    return this._dto.subscription.id;
  }

  get subscriptionName() {
    return this._dto.subscription.name;
  }

  get productIcon() {
    return this._dto.subscription.product?.iconUrl;
  }

  get optimizationPoints() {
    return this._optimizationPoints;
  }

  get userOptimizationPoints() {
    return this._optimizationPoints.filter(model => model.isUserOptimzationPoint);
  }

  get planOptimizationPoints() {
    return this._optimizationPoints.filter(model => model.isPlanOptimizationPoint);
  }

  get updatedDate() {
    return this._dto.updatedDate;
  }
}
